<template>
  <section
    id="pagePath"
    class="pages-path d-flex mt-2 mt-lg-4 align-items-baseline fontsize12 text-black  py-2 "
  >
    <div class="container content-pagePath d-flex align-items-center box-shaddow20 bg-white text-right">
      <router-link class=" text-black" to="/" style="transform: translateY(-3px);">
        <!-- <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-width="1.5"
            stroke="#fff"
            d="M9.13478 20.7733V17.7156C9.13478 16.9351 9.77217 16.3023 10.5584 16.3023H13.4326C13.8102 16.3023 14.1723 16.4512 14.4393 16.7163C14.7063 16.9813 14.8563 17.3408 14.8563 17.7156V20.7733C14.8539 21.0978 14.9821 21.4099 15.2124 21.6402C15.4427 21.8705 15.7561 22 16.0829 22H18.0438C18.9596 22.0023 19.8388 21.6428 20.4872 21.0008C21.1356 20.3588 21.5 19.487 21.5 18.5778V9.86686C21.5 9.13246 21.1721 8.43584 20.6046 7.96467L13.934 2.67587C12.7737 1.74856 11.1111 1.7785 9.98539 2.74698L3.46701 7.96467C2.87274 8.42195 2.51755 9.12064 2.5 9.86686V18.5689C2.5 20.4639 4.04738 22 5.95617 22H7.87229C8.55123 22 9.103 21.4562 9.10792 20.7822L9.13478 20.7733Z"
          />
        </svg> -->
        <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.9258 4.38469L9.32578 1.79373C8.34453 1.08652 6.83828 1.1251 5.89453 1.87731L2.76328 4.39111C2.13828 4.89259 1.64453 5.92126 1.64453 6.73133V11.1675C1.64453 12.8069 2.93828 14.1442 4.53203 14.1442H11.2695C12.8633 14.1442 14.157 12.8133 14.157 11.1739V6.81491C14.157 5.94697 13.6133 4.87973 12.9258 4.38469ZM8.36953 11.5725C8.36953 11.8361 8.15703 12.0547 7.90078 12.0547C7.64453 12.0547 7.43203 11.8361 7.43203 11.5725V9.64375C7.43203 9.38015 7.64453 9.16156 7.90078 9.16156C8.15703 9.16156 8.36953 9.38015 8.36953 9.64375V11.5725Z" fill="#999999"/>
          </svg>
          
      </router-link>
      <router-link to="/" class="fontsize-mini text-black" 
        >خانه
      </router-link>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="11"
        height="11"
        fill="currentColor"
        class=" bi bi-chevron-double-left"
        viewBox="0 0 16 16"
      >
        <path
          fill-rule="evenodd"
          d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
        />
        <path
          fill-rule="evenodd"
          d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
        />
      </svg>
      <!-- <svg v-if="pathTitle1" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="">
        <path d="M15.5 19L8.5 12L15.5 5" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg> -->
      <!-- <span>محصولات</span> -->
      <router-link
        :to="pathTo1 ? pathTo1 : ''"
        class="cursor-pointer fontsize-mini  text-black w-s-nowrap"
        >{{ pathTitle1 }}</router-link
      >
      <svg
        v-if="pathTitle2"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class=""
      >
        <path
          d="M15.5 19L8.5 12L15.5 5"
          stroke="#999999"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <router-link
        :to="$route.path"
        v-if="pathTitle2"
        class="fontsize-mini text-black bread-crumb-text-overflow"
        >{{ pathTitle2 }}</router-link
      >
    </div>
    <!-- <a class="d-none d-md-block" id="backPageArrow" @click="backLink()">
      <svg
      width="24"
      fill="#999999"
        xmlns="http://www.w3.org/2000/svg"
        shape-rendering="geometricPrecision"
        text-rendering="geometricPrecision"
        image-rendering="optimizeQuality"
        fill-rule="evenodd"
        clip-rule="evenodd"
        viewBox="0 0 512 404.43"
      >
        <path
          fill-rule="nonzero"
          d="m68.69 184.48 443.31.55v34.98l-438.96-.54 173.67 159.15-23.6 25.79L0 199.94 218.6.02l23.6 25.79z"
        />
      </svg>
    </a> -->
  </section>
</template>

<script>
export default {
  name: "PagesPath",
  props: ["pathTitle1", "pathTo1", "pathTitle2"],
  methods: {
    backLink() {
      history.back();
    },
  },
};
</script>

<style scoped>
.content-pagePath{
  border-radius: 20px;
  padding: 14px 24px;
  gap: 8px;
}
.pages-path a.link {
  vertical-align: text-top;
  color: white;
}

path {
  /*stroke: white;*/
}

#backPageArrow {
  position: relative;
  left: 16px;
  display: none;
}
@media (max-width: 1023px){
  .bread-crumb-text-overflow{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
}
@media (max-width: 768px) {
  #backPageArrow {
    display: unset;
  }
}
</style>
